import { FormArray, FormGroup } from '@angular/forms';

import type { PendingDropdownItem, RepeatableLogger, RepeatableResolutionResult } from './repeatable-group.types';
import { RepeatableDropdownResolver } from './repeatable-dropdown.resolver';
import { RepeatableValueUtils } from './repeatable-value.utils';

export class RepeatablePendingDropdownResolver {
    public constructor(
        private readonly dropdownResolver: RepeatableDropdownResolver,
        private readonly logger: RepeatableLogger,
    ) {}

    public resolvePending(rowsArray: FormArray<FormGroup>, pendingDropdown: PendingDropdownItem[]): RepeatableResolutionResult {
        const stillPending: PendingDropdownItem[] = [];
        let didResolveAny = false;

        for (const item of pendingDropdown) {
            const rowGroup = rowsArray.at(item.rowIndex);
            const control = rowGroup?.get(item.logicalKey);

            if (!control) {
                this.logger.warn('tryResolvePending(): control missing.', { item });
                continue;
            }

            const primaryKey = item.sf.input?.dropdownConfiguration?.valuePrimaryKey ?? 'id';
            const options = this.dropdownResolver.options(item.sf, item.rowIndex);

            if (!item.isMulti) {
                const id = item.rawIds[0] ?? '';
                const selectedObject = this.dropdownResolver.mapIdToDropdownValue(id, item.sf, item.rowIndex);

                if (selectedObject) {
                    control.patchValue(selectedObject, { emitEvent: false });
                    didResolveAny = true;
                } else {
                    stillPending.push(item);
                }

                continue;
            }

            const currentValue = Array.isArray(control.value) ? (control.value as unknown[]) : [];
            const resolvedNow = item.rawIds
                .map((id) => options.find((option) => RepeatableValueUtils.getOptionKey(option?.value, primaryKey) === id)?.value ?? null)
                .filter((value) => value !== null);

            if (resolvedNow.length > 0) {
                control.patchValue([...currentValue, ...resolvedNow], { emitEvent: false });
                didResolveAny = true;
            }

            const unresolvedIds = item.rawIds.filter((id) => !options.some((option) => RepeatableValueUtils.getOptionKey(option?.value, primaryKey) === id));

            if (unresolvedIds.length > 0) {
                stillPending.push({ ...item, rawIds: unresolvedIds });
            }
        }

        return { stillPending, didResolveAny };
    }
}
